import { Component, OnInit, ViewChild, Pipe, PipeTransform } from '@angular/core';
import { PopoverDirective } from 'ngx-bootstrap/popover';
import { AuthService } from '../../../core/auth/auth.service'
import { CustomerService } from '../../../core/customer/customer.service';
import { MenuItem } from 'primeng/primeng';
import { Router } from '@angular/router';
import { CustomerModel } from '../../../core/customer/customer.model';
import { GameVerificationService } from "../../../core/verify/game-verification-service";

@Component({
  selector: 'app-header',
  templateUrl: 'header.component.html',
  styleUrls: ['header.scss']
})
export class HeaderComponent implements OnInit {

  lengthShoppingCart = 0;//this.shoppingCart.shoppingCart.juegos.length;
  @ViewChild('signinPop') signinPop: PopoverDirective;
  //@ViewChild('signupPop') signupPop: PopoverDirective;

  messages = [];
  //customer: CustomerModel;
  userName: string;
  isOpen = false;

  constructor(
    public auth: AuthService,
    private _router: Router,
    private _customerService: CustomerService,
    public gameVerificationService: GameVerificationService
  ) {

  }

  logout() {
    this.auth.logout().subscribe();
    this._router.navigate(['landing/home']);
  }

  ngOnInit(): void {
 
    this.getUserInfo();
  }

  private getUserInfo() {
    //this.isLoading = true;
    if (this.auth.user === null && this.auth.user === undefined) {
      
      this._customerService.getCustomerByUsername()
        //.finally(() => this.isLoading = false)
        .subscribe(
        customer => {
        },
        err => {
          console.error('getuserInfo error, ', err);
        });
    }
  }

  

  openMenu() {
    this.isOpen = this.isOpen ? false : true;
  }

  showProfile() {
    this._router.navigate(['juegos/management-profile']);
  }

  onSignin() {
    this.signinPop.hide();
  }

  onSignup(event) {
    //this.signupPop.hide();
    console.log(event);
    if (event && event.message)
      this.messages.push({ severity: 'success', summary: '', detail: event.message });
  }

  toggleSigninPop() {
    console.log('se debe mostrar el pop');
    //this.signupPop.hide();
    this.signinPop.toggle();
  }

  toggleSignupPop() {
    this.signinPop.hide();
    //this.signupPop.toggle();
  }
}



// WEBPACK FOOTER //
// /jenkins/jenkins/workspace/apppronosticos_install_s3_dev/src/app/layouts/shared/header/header.component.ts